import styled from "styled-components";
import { flex } from "waapi/waap-ui/components/Flex/Flex.style.js";

export const StyledFlex = styled.div`
    ${flex};
    padding-left: ${({ theme }) => theme.spacing[32]};
`;
